import { defineStore } from 'pinia'
import type { VNode } from 'vue'
import { computed, ref } from 'vue'

export const useSlideOutPanelStore = defineStore('slideOutPanel', () => {
  const isVisible = ref(false)
  const width = ref(600)
  const slotContent = ref<VNode | null>(null)

  const panelStyle = computed(() => ({
    width: `${width.value}px`,
  }))

  function show(content: VNode | null = null) {
    isVisible.value = true
    slotContent.value = content
  }

  function hide() {
    isVisible.value = false
    slotContent.value = null
  }

  return {
    isVisible,
    width,
    slotContent,
    panelStyle,
    show,
    hide,
  }
})
